import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminPage } from './pages/AdminPage.js';
import { ConfirmationPage } from './pages/ConfirmationPage.js';
import { ContactPage } from './pages/ContactPage.js';
import { HomePage } from './pages/HomePage.js';
import { IntakePage } from './pages/IntakePage.js';
import { InvitationPage } from './pages/InvitationPage.js';
import { LegalPage } from './pages/LegalPage.js';
import { PlacePage } from './pages/PlacePage.js';
import { ProofPage } from './pages/ProofPage.js';
import { ReportGate } from './pages/ReportGate.js';
import { SummaryPage } from './pages/SummaryPage.js';
import { AccessPage } from './pages/AccessPage.js';
import { TrackingPage } from './pages/TrackingPage.js';
import { VenueCasePage } from './pages/VenueCasePage.js';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/v/:code" element={<InvitationPage />} />
      <Route path="/access/:role" element={<AccessPage />} />
      <Route path="/track" element={<TrackingPage />} />
      <Route path="/venue/case" element={<VenueCasePage />} />
      <Route path="/report" element={<ReportGate />}>
        <Route index element={<Navigate to="intake" replace />} />
        <Route path="intake" element={<IntakePage />} />
        <Route path="place" element={<PlacePage />} />
        <Route path="proof" element={<ProofPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="summary" element={<SummaryPage />} />
        <Route path="confirmation" element={<ConfirmationPage />} />
      </Route>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/legal/:document" element={<LegalPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
